import {
  GetSpaceCapacityEventFragment,
  GetSpaceCapacityProposalFragment,
} from './getSpaceCapactiy.generated-types'

interface GetSpaceCapacityArgs {
  event: GetSpaceCapacityEventFragment
  proposal: GetSpaceCapacityProposalFragment
}

export const getSpaceCapacity = ({
  event: { layoutID },
  proposal: {
    space: { spatialConfigurations },
  },
}: GetSpaceCapacityArgs): number => {
  const enquiryLayoutMatchedCapacity = spatialConfigurations.find(
    (conf) => conf.name === layoutID
  )?.capacity

  if (enquiryLayoutMatchedCapacity) {
    return enquiryLayoutMatchedCapacity
  }

  const maxLayoutCapacity = spatialConfigurations.reduce((prev, current) =>
    prev.capacity > current.capacity ? prev : current
  ).capacity
  return maxLayoutCapacity
}
